import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../public/img/home/h264homemp43.mp4'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  loop: "",
  autoplay: "",
  muted: "",
  controlsList: "nodownload",
  style: {"width":"100%","height":"auto"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"top":"38%","left":"11%","position":"absolute"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-font" }, "赋能生态合作伙伴"),
  /*#__PURE__*/_createElementVNode("div", { class: "top-font" }, "助力行业数字化创新"),
  /*#__PURE__*/_createElementVNode("div", { class: "bo-font" }, "为客户构建数字化服务平台，建立云上行业解决方案，携手共赢")
], -1)
const _hoisted_3 = { class: "home-content" }
const _hoisted_4 = { class: "home-product" }
const _hoisted_5 = { class: "home-quanwei" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_Solution = _resolveComponent("Solution")!
  const _component_Case = _resolveComponent("Case")!
  const _component_Activity = _resolveComponent("Activity")!
  const _component_Kefu = _resolveComponent("Kefu")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_carousel, {
        trigger: "click",
        arrow: "never"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (item) => {
            return _createVNode(_component_el_carousel_item, { key: item }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Solution)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Case)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Activity)
    ]),
    _createVNode(_component_Kefu),
    _createVNode(_component_Footer)
  ], 64))
}